import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Contract from "@/model/contract";
import Property from "@/model/property";
import FloorArea from "@/model/floorArea";
import FileModel from "@/model/file";

export interface CheckPoint {
  id: string;
  _id: string;
  area: FloorArea,
  floor_plan_area_id: string,
  comment: string,
  images: FileModel[]
};

@Module({ namespaced: true })
export default class ConfirmContractModule extends VuexModule {
  public contract: Contract = null;
  public property: Property = null;
  // follow data
  public checkListSelected: [] = [];
  public checkPoint: CheckPoint[] = [];

  @Mutation
  updateContract(contract: Contract) {
    this.contract = contract;
  }

  @Mutation
  updateProperty(property: Property) {
    this.property = property;
  }

  @Mutation
  updateCheckPoint(checkPoint: []) {
    this.checkPoint = checkPoint;
  }

  @Mutation
  updateCheckListSelected(value) {
    this.checkListSelected = value;
  }
  @Mutation
  clearAll() {
    this.contract = null;
    this.property = null;
    // follow data
    this.checkListSelected = [];
    this.checkPoint = [];
  }


  @Action
  setContract(contract: Contract) {
    this.context.commit('updateContract', contract)
  }

  @Action
  setProperty(property: Property) {
    this.context.commit('updateProperty', property)
  }

  @Action
  setCheckListSelected(value) {
    this.context.commit('updateCheckListSelected', value)
  }

  @Action
  setCheckPoint(checkPoint) {
    // this.checkPoint
    this.context.commit('updateCheckPoint', checkPoint)
  }

  @Action
  clear() {
    // this.checkPoint
    this.context.commit('clearAll')
  }

  get getContract() {
    return this.contract;
  }

  get getCheckPoint() {
    return this.checkPoint;
  }

  get getProperty() {
    return this.property;
  }

  get getCheckListSelected() {
    return this.checkListSelected;
  }
}

// export default getModule(AuthModule);
